import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authService } from "../../services/authService";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await authService.login(credentials);
      return response.data.dataUser; // Trả về user info
    } catch (error) {
      console.log("Lỗi nhận được:", error); // Kiểm tra lỗi trong console

      // Lấy thông tin lỗi và đưa vào Redux
      if (error.response && error.response.status === 401) {
        return rejectWithValue(
          error.response?.data?.message || "Xác thực thất bại!"
        );
      }
      return rejectWithValue("Đã xảy ra lỗi không xác định");
    }
  }
);

export const loginGoogle = createAsyncThunk(
  "auth/loginGoogle",
  async (loginGoogleDTO, { rejectWithValue }) => {
    try {
      const response = await authService.loginGoogle(loginGoogleDTO);
      return response.data.dataUser; // Trả về user info
    } catch (error) {
      console.log("Lỗi nhận được:", error); // Kiểm tra lỗi trong console
      return rejectWithValue(
        error.response?.data?.message || "Xác thực thất bại!"
      );
    }
  }
);

export const loginFacebook = createAsyncThunk(
  "auth/loginFacebook",
  async (accessToken, { rejectWithValue }) => {
    try {
      const response = await authService.loginFacebook(accessToken);
      return response.data.dataUser; // Trả về user info
    } catch (error) {
      console.log("Lỗi nhận được:", error); // Kiểm tra lỗi trong console
      return rejectWithValue(
        error.response?.data?.message || "Xác thực thất bại!"
      );
    }
  }
);

export const confirmEmail = createAsyncThunk(
  "auth/confirmEmail",
  async ({ userId, token }, { rejectWithValue }) => {
    try {
      const response = await authService.confirmEmail(userId, token);
      return response.data.message;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Xác thực thất bại!"
      );
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (resetPasswordDTO, { rejectWithValue }) => {
    try {
      const response = await authService.resetPassword(resetPasswordDTO);
      return response.data.message;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Xác thực thất bại!"
      );
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null, // Lưu thông tin user (id, name, role)
    loading: false,
    error: null,
    status: "",
    message: null,
    authSource: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.loading = false;
      state.error = null;
      state.status = "";
      state.message = null;
      state.authSource = null;
      sessionStorage.removeItem("hasShownToast");
      localStorage.removeItem("persist:root");
    },
    clearRedux: (state) => {
      state.status = "";
      state.error = null;
      state.message = null;
      state.authSource = null;
    },
    setUser: (state, action) => {
      state.user = action.payload; // Lưu token mới
    },
  },
  extraReducers: (builder) => {
    builder
      //Login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //Login Google
      .addCase(loginGoogle.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.authSource = "google";
      })
      .addCase(loginGoogle.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
      })
      .addCase(loginGoogle.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //Login Facebook
      .addCase(loginFacebook.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.authSource = "facebook";
      })
      .addCase(loginFacebook.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
      })
      .addCase(loginFacebook.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //Confirm Email
      .addCase(confirmEmail.pending, (state) => {
        state.status = "loading";
        state.message = "Hệ thống đang xác nhận email của bạn...";
        state.error = null;
      })
      .addCase(confirmEmail.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload;
        state.error = null;
      })
      .addCase(confirmEmail.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      //Reset Password
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.message = "";
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.error = null;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, clearRedux, setUser } = authSlice.actions;
export default authSlice.reducer;
